import {
  useRoute
} from 'vue-router'
import CardHeaderScheduleBusDetail from '@/views/transactions/schedule-bus/detail/components/CardHeaderScheduleBusDetail.vue'
import DetailSchedule from '@/views/transactions/schedule-bus/detail/detail-schedule/DetailSchedule.vue'

export default {
  name: 'ScheduleBusDetail',
  components: {
    CardHeaderScheduleBusDetail,
    DetailSchedule
  },
  setup() {
    const route = useRoute()
    const getDecriptId = () => route.params.idJadwal
    return {
      getDecriptId,
      route
    }
  }
}